import { Navigate, useLocation, useParams } from "react-router";
import { resolveRedirect } from "../lib/redirects";

/** <Navigate replace> to the new home of an old URL, keeping the query string. */
export function LegacyRedirect({ to }: { to: string }) {
  const params = useParams();
  const { search } = useLocation();
  return <Navigate to={{ pathname: resolveRedirect(to, params), search }} replace />;
}
